import {useCallback} from 'react';

import {$invoiceLineChargeData} from 'models/documents/invoices/create';

interface UseFormLineCalculationsParams {
    getValues?: (x?: string | string[]) => any;
    setValue?: (x: string, q: string) => any;
    trigger?: (name?: string | string[] | undefined) => Promise<boolean>;
}

const checkIfNumber = (values: string[], name: string, setValue: (x: string, q: string) => any) => {
    if (values.some((i) => !i)) {
        setValue(name, '');
        return false;
    }

    if (values.some((i) => isNaN(Number(i)))) {
        setValue(name, '');
        return false;
    }

    return true;
};

export const useFormLineCalculations = ({
    getValues,
    setValue,
    trigger,
}: UseFormLineCalculationsParams = {}) => {
    const combineValues = useCallback(() => {
        if (!getValues || !setValue || !trigger) {
            return;
        }
        const values = getValues(['qty', 'price']);
        const {price, qty} = values;
        const name = 'lines';
        trigger(name);

        if (!checkIfNumber([price, qty], name, setValue)) {
            return;
        }

        const item = $invoiceLineChargeData.getState();
        const multiplier = item?.isCharge === 'true' ? 1 : -1;
        const xaf = item?.amountXaf ? Number(item.amountXaf) * multiplier : 0;
        const mutiplie = Number(price) * Number(qty) + xaf;
        setValue(name, mutiplie.toFixed(2));
        trigger(name);
    }, [getValues, setValue, trigger]);

    const calculateLineAmountWVat = useCallback(() => {
        if (!getValues || !setValue || !trigger) {
            return;
        }
        const values = getValues(['vat', 'lines']);
        const name = 'lineAmountWVat';
        trigger(name);
        const {vat, lines} = values;
        if (!checkIfNumber([vat, lines], name, setValue)) {
            return;
        }

        const mutiplie = Number(lines) + (Number(lines) * Number(vat)) / 100;

        setValue(name, mutiplie.toFixed(2));
        trigger(name);
    }, [getValues, setValue, trigger]);

    return {
        combineValues,
        calculateLineAmountWVat,
    };
};
